const Project1 = () => {
    return (
      <div>
        <h1>Project 4: wiskerwags</h1>
        <p>This is a MERN Stack project, i.e. based on React, Node.js, Express.js and MongoDB. The purpose of this project was to create a pet adoption portal.</p>
      </div>
    );
  };
  
  export default Project1;
  